import { useAuth } from '../auth/AuthProvider';
import { SimboloMarcaBlanco } from '../components/Marca';
import { IconCerrar } from './icons';
import { DESTINOS_NAV } from './navItems';
import { SidebarNav } from './SidebarNav';

interface Props {
  abierto: boolean;
  onCerrar: () => void;
}

/** Version movil del Sidebar: drawer off-canvas bajo el breakpoint md. */
export function MobileNav({ abierto, onCerrar }: Props) {
  const { tieneRol } = useAuth();
  const destinos = DESTINOS_NAV.filter((d) => tieneRol(...d.roles));

  return (
    <div
      className={`fixed inset-0 z-40 md:hidden ${abierto ? '' : 'pointer-events-none'}`}
      aria-hidden={!abierto}
    >
      <div
        className={`absolute inset-0 bg-navy/40 transition-opacity duration-200 ${
          abierto ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={onCerrar}
      />
      <div
        className={[
          'absolute inset-y-0 left-0 flex w-72 max-w-[80vw] flex-col bg-navy py-5 shadow-xl transition-transform duration-200',
          abierto ? 'translate-x-0' : '-translate-x-full',
        ].join(' ')}
      >
        <div className="flex items-center justify-between px-4">
          <div className="flex items-center gap-2.5">
            <SimboloMarcaBlanco className="h-8 w-8 shrink-0" />
            <span className="font-marca text-base font-semibold text-white">Eventos CIEN</span>
          </div>
          <button
            type="button"
            onClick={onCerrar}
            aria-label="Cerrar menú"
            className="flex h-8 w-8 items-center justify-center rounded-full text-white/70 hover:bg-white/10"
          >
            <IconCerrar className="h-5 w-5" />
          </button>
        </div>

        <div className="mt-8 flex-1 overflow-y-auto">
          <SidebarNav destinos={destinos} onNavigate={onCerrar} />
        </div>
      </div>
    </div>
  );
}
